/**
 * The first segments of an address that are the app's on a workspace address (ADR-0098 stage 2):
 * its own screens, API and files. A page's readable address never starts with one of them, so
 * `latin.rodericus.net/inbox` is always the inbox and `/lectiones` always a page. Shared by the
 * server, which skips them when it gives pages their addresses, and the app's router.
 */
export const APP_PATH_SEGMENTS: ReadonlySet<string> = new Set([
  "w",
  "api",
  "assets",
  "_paginae",
  "new-workspace",
  "shared",
  "comment",
  "template",
  "inbox",
  "setup",
  "sign-in",
  "email",
  "f",
  "invite",
  "recover",
  "account",
  "oauth",
  "help",
  "admin",
]);

/** Whether a stored or requested path (`/inbox`, `/admin/…`) is one of the app's own. */
export function isAppPath(path: string): boolean {
  const first = path.split("/")[1] ?? "";
  return APP_PATH_SEGMENTS.has(first.toLowerCase());
}
